module.exports = __webpack_public_path__ + "img/mp.1f056a1f.png";